import { Store } from "../../../__generated__/graphql";
import { StoreCardForNewOne } from "../../../components/store-card/store-card-for-new-one";
import type { StoreCoupon } from "../../../components/store-card/types";

export interface HomeNewStoresSectionProps {
  newStores: Store[];
  onClickLike: (
    storeId: number,
    isLiked: boolean | null,
    storeTitle?: string,
  ) => void | Promise<void>;
  onOpenSheet: (e: React.MouseEvent) => void;
  onClickStore: (store: Store, type: string) => void;
  navigate: (path: string) => void;
}

export function HomeNewStoresSection({
  newStores,
  onClickLike,
  onOpenSheet,
  onClickStore,
}: HomeNewStoresSectionProps) {
  if (!Array.isArray(newStores) || newStores.length === 0) return null;

  return (
    <div>
      <h2 className="font-bold ml-5 mt-4">🎉 새로 입점한 매장이에요</h2>
      <div className="flex flex-row p-4 overflow-x-scroll gap-4">
        {newStores.map((store) => (
          <div className="mb-4 w-1/2 flex-shrink-0" key={store.id}>
            <StoreCardForNewOne
              title={store.title as string}
              distance={store.distance}
              img={store.img as string}
              isLiked={store.isLiked}
              onClickHeart={async (e) => {
                e.stopPropagation();
                await onClickLike(
                  store.id,
                  store.isLiked ?? null,
                  store.title ?? undefined,
                );
              }}
              openSheet={(e: React.MouseEvent) => {
                e.stopPropagation();
                onOpenSheet(e);
              }}
              onClick={() => onClickStore(store, "새로 입점한 매장")}
              availableStoreCoupon={
                store.availableStoreCoupon as StoreCoupon | undefined
              }
            />
          </div>
        ))}
      </div>
      <hr />
    </div>
  );
}
